module.exports = __webpack_public_path__ + "img/header-phoneicon.8a05b72.webp";